import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { connect } from "react-redux";

import { CARDS_IMAGES } from "../../../../constants";
import * as actions from "../../../../store/actions";

import AddCardForm from "./AddCardForm";
import ProfileIcon from "../../../../components/uiElements/icons/profileIcons/ProfileIcon";
import Button from "../../../../components/formElements/button/Button";
import SpinnerBorder from "../../../../components/uiElements/loadingSpinner/SpinnerBorder";

import classnames from "classnames";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const CardComponent = ({
  addCard,
  getPaymentMethods,
  deleteCard,
  accountDetails,
  setAccountDetails,
  onPayment,
  price,
}) => {
  const [showCardForm, setShowCardForm] = useState(false);

  useEffect(() => {
    getPaymentMethods();
    // eslint-disable-next-line
  }, []);

  const { selectedSubscription, selectedCard, paymentMethods } = accountDetails;

  return (
    <>
      {!showCardForm && paymentMethods?.length > 0 && (
        <div>
          <div className="d-flex justify-content-between align-items-center">
            <span
              style={{
                padding: "0 24px",
                color: "#333333",
              }}
              className="font-weight-bold"
            >
              Saved Cards
            </span>
            {!showCardForm && paymentMethods?.length > 0 && (
              <Button
                type="outline"
                label={"Add Card"}
                className={classnames("col-md-3 mr-4 h-25")}
                onClick={() => setShowCardForm(true)}
              />
            )}
          </div>
          <ul className="card-list px-4">
            {accountDetails.getCardsLoading ||
            accountDetails.deleteCardLoading ? (
              <SpinnerBorder size="md" isCenter />
            ) : (
              paymentMethods.map(paymentMethod => (
                <>
                  <li
                    className="row card-row m-0 p-0 mb-3"
                    style={{
                      cursor: "pointer",
                      background:
                        selectedCard?.id === paymentMethod?.id && "#BDD8F2",
                    }}
                    onClick={() =>
                      setAccountDetails({ selectedCard: paymentMethod })
                    }
                  >
                    <img
                      alt={paymentMethod?.card?.id}
                      src={CARDS_IMAGES[paymentMethod?.card?.brand]}
                      className="col-md-1 card-brand"
                    />
                    <label
                      className="col-md-8 my-auto"
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 20,
                        }}
                      >
                        •••• •••• ••••
                      </span>{" "}
                      {paymentMethod?.card?.last4}{" "}
                    </label>
                    <span
                      className="col-md-3 my-auto text-right"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => deleteCard(paymentMethod?.id)}
                    >
                      <ProfileIcon type="delete" />
                    </span>
                  </li>
                </>
              ))
            )}
          </ul>
        </div>
      )}
      {(showCardForm || paymentMethods?.length === 0) && (
        <Elements stripe={stripePromise}>
          <div className="card-wrapper">
            <div className="add-card">
              <p
                className="font-weight-bold"
                style={{
                  color: "#333333",
                }}
              >
                Add Card
              </p>
              <AddCardForm
                addCard={token => addCard(token, () => setShowCardForm(false))}
                onRemove={() => setShowCardForm(false)}
                isCancelDisabled={paymentMethods?.length === 0}
                isLoading={accountDetails?.addCardLoading}
                setLoading={value =>
                  setAccountDetails({ addCardLoading: value })
                }
              />
            </div>
          </div>
        </Elements>
      )}
      <div className="bottom-buttons">
        {!showCardForm && paymentMethods?.length > 0 && (
          <Button
            className="w-25 mx-auto content-center"
            label={
              accountDetails?.addSubscriptionLoading ? (
                <SpinnerBorder />
              ) : (
                <span>{`Pay $${
                  price || selectedSubscription?.unit_amount
                }`}</span>
              )
            }
            disabled={!selectedCard}
            onClick={() => onPayment("card")}
          />
        )}
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, auth, api }) => ({
  apiUtil: api,
  accountDetails: onboarding?.accountDetails,
});

const mapDispatchToProps = dispatch => ({
  addCard: (token, cb) => dispatch(actions.addPaymentMethod(token, cb)),
  getPaymentMethods: cb => dispatch(actions.getCustomerCardDetails(cb)),
  deleteCard: cardId => dispatch(actions.deleteUserCardDetails(cardId)),
  setAccountDetails: updatedData =>
    dispatch(actions.setAccountDetails(updatedData)),
  retrieveBankAccount: () => dispatch(actions.retrieveBankAccount()),
});

export default connect(mapStoreToProps, mapDispatchToProps)(CardComponent);
